import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c2c40eb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Zaloguj się")
], -1))
const _hoisted_3 = {
  key: 1,
  class: "spinner-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CInputGroupText = _resolveComponent("CInputGroupText")!
  const _component_CFormInput = _resolveComponent("CFormInput")!
  const _component_CInputGroup = _resolveComponent("CInputGroup")!
  const _component_CButton = _resolveComponent("CButton")!
  const _component_CForm = _resolveComponent("CForm")!
  const _component_CCol = _resolveComponent("CCol")!
  const _component_CRow = _resolveComponent("CRow")!
  const _component_CContainer = _resolveComponent("CContainer")!
  const _component_CSpinner = _resolveComponent("CSpinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_CContainer, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_CRow, { class: "justify-content-center align-items-center" }, {
              default: _withCtx(() => [
                _createVNode(_component_CCol, {
                  md: "8",
                  lg: "6",
                  xl: "5"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CForm, {
                      onSubmit: _ctx.submitForm,
                      class: "login-form"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2,
                        _createVNode(_component_CInputGroup, { class: "mb-3" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_CInputGroupText, null, {
                              default: _withCtx(() => [
                                _createTextVNode("@")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_CFormInput, {
                              modelValue: _ctx.email,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                              type: "email",
                              placeholder: "stacja@watis.com.pl",
                              autocomplete: "email"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_CInputGroup, { class: "mb-4" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_CFormInput, {
                              modelValue: _ctx.password,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                              type: "password",
                              placeholder: "********",
                              autocomplete: "password"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_CButton, {
                          type: "submit",
                          color: "success",
                          class: "w-100"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Login ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["onSubmit"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_CSpinner, {
            color: "success",
            class: "loading-spinner"
          })
        ]))
  ]))
}